import type {
  HubAlgorithm,
  HubBuildState,
} from '@robovision/hub'
import { capitalize } from 'lodash-es'


export interface AlgorithmParams {
  apiVersion: string
  buildState: HubBuildState
  createdAt: Date
  description?: string
  extension?: boolean
  hash: string
  id: string
  name: string
  type?: string
  version: string
}

export class Algorithm {
  public static modelName = 'Algorithm'

  private readonly _type: string
  public readonly apiVersion: string
  public readonly buildState: HubBuildState
  public readonly createdAt: Date
  public readonly description?: string
  public readonly extension: boolean
  public readonly hash: string
  public readonly id: string
  public readonly name: string
  public readonly version: string

  public constructor (params: AlgorithmParams) {
    this._type = params.type ?? ''
    this.apiVersion = params.apiVersion
    this.buildState = params.buildState
    this.createdAt = params.createdAt
    this.description = params.description
    this.extension = params.extension ?? false
    this.hash = params.hash
    this.id = params.id
    this.name = params.name
    this.version = params.version

    Object.freeze(this)
  }

  public get key () {
    return `${this.id}__${this.version}`
  }

  public get type () {
    const type = this._type
      .split('.')
      .at(-1)
      ?.split(/(?=[A-Z])/)
      .map(v => v.trim())
      .join(' ') ?? ''

    return capitalize(type)
  }

  public static fromResponse (data: HubAlgorithm) {
    return new Algorithm({
      apiVersion: data.apiVersion,
      buildState: data.buildState,
      createdAt: new Date(data.createdAt),
      description: data.description,
      extension: data.extension,
      hash: data.hash,
      id: data.id,
      name: data.name,
      type: data.type,
      version: data.version,
    })
  }
}
